export const copyToClipboard = async (str: string): Promise<boolean> => {
    try {
        await navigator.clipboard.writeText(str);
        return true;
    } catch {
        try {
            const textarea = document.createElement('textarea');
            textarea.value = str;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            const success = document.execCommand('copy');
            document.body.removeChild(textarea);
            if (!success) throw new Error('execCommand copy failed');
            return true;
        } catch (err:unknown) {
            if(err instanceof Error) {
                throw new Error(err?.message);
            }
            throw new Error('Clipboard copy failed');
        }
    }
};

export const copyToIOSClipboard = async (str: string): Promise<boolean> => {
    // NOTE:
    // - `ClipboardItem` is not available in all browsers/environments.
    // - iOS Safari historically has partial clipboard support.
    // So we try the rich clipboard API if available, then fall back to `execCommand('copy')`.

    // 1) Rich clipboard API (if supported)
    try {
        const ClipboardItemCtor = (globalThis as any)?.ClipboardItem;
        if (ClipboardItemCtor && navigator.clipboard?.write) {
            const clipboardItem = new ClipboardItemCtor({
                "text/plain": new Blob([str], { type: "text/plain" }),
            });
            await navigator.clipboard.write([clipboardItem]);
            return true;
        }
    } catch {
        // ignore and fallback
    }

    // 2) Fallback: hidden textarea + execCommand('copy')
    try {
        const textarea = document.createElement("textarea");
        textarea.value = str;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "fixed";
        textarea.style.top = "-9999px";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        const ok = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (!ok) throw new Error("execCommand returned false");
        return true;
    } catch (err: any) {
        throw new Error(err?.message ?? "Clipboard copy fallback failed");
    }
};